import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { ApiBaseService } from './api-base.service';
import { SharedService } from './shared.service';

import { CommunityFormModel, CommunityModel } from '@shared/models/CommunityModel';
import { CommunityCustomerModel } from '../shared/models/CommunityModel';
import { CommunitySearchModel } from '@shared/models/SearchModel';
import { communities, vendors } from '@shared/mock-data';
import { Country } from '@shared/models/Enums';


@Injectable()
export class ApiCommunityService extends ApiBaseService {

    constructor(public http: HttpClient, public sharedService: SharedService) {
        super(http, sharedService);
    }

    // POST: api/admin/communities/customer/reads/v1
    getAllCommunitiesByCustomer(id: number, country?: Country): Promise<CommunityModel[]> {

        return this.http.post(`${this.baseUrl}/api/admin/communities/customer/reads/v1/${id}`, null, this.getHttpOptions(country))
            .toPromise().then(
                (results: any) => {

                    let allCommunities = results.map(x => {

                        return new CommunityModel(x);
                    })

                    return allCommunities;

                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de los cupones: ${errMsg}`));
                }
            );
    }

    // POST: api/admin/communities/reads/v1
    getAllCommunities(search: CommunitySearchModel): Promise<CommunityModel[]> {

        return this.http.post(`${this.baseUrl}/api/admin/communities/reads/v1`, search, this.getHttpOptions())
            .toPromise().then(
                (results: any) => {

                    let allCommunities = results.map(x => {

                        return new CommunityModel(x);
                    }).sort((a, b) => {

                        if (a.vendors && b.vendors) {
                            return b.vendors.length - a.vendors.length;
                        } 
                        return b.id - a.id;
                    });

                    // Clean and set the communities to cache
                    while (communities.length) communities.pop();
                    allCommunities.forEach(x => communities.push(x));

                    return allCommunities;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de los cupones: ${errMsg}`));
                }
            );
    }

    // GET: api/admin/communities/reads/v1/{id}
    getCommunity(id: number, country?: Country): Promise<CommunityModel> {

        return this.http.get(`${this.baseUrl}/api/admin/communities/reads/v1/${id}`, this.getHttpOptions(country))
            .toPromise().then(
                (results: any) => {

                    let fullCommunity = new CommunityModel(results);

                    return fullCommunity;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de la comunidad: ${errMsg}`));
                }
            );
    }

    //-------------------------------------------- FORM --------------------------------------------
    // GET: api/admin/communities/forms/reads/v1/{id}
    getFullCommunityForms(communityId: number): Promise<CommunityFormModel> {

        return this.http.get(`${this.baseUrl}/api/admin/communities/forms/reads/v1/${communityId}`, this.getHttpOptions())
            .toPromise().then(
                (result: any) => {

                    // Todos los formularios por comunidad
                    let allCommunityForm = result;

                    return allCommunityForm;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de los cupones: ${errMsg}`));
                }
            );
    }

    // GET: api/admin/communities/form/reads/v1/{id}
    getFullCommunityForm(id: number, country?: Country): Promise<CommunityFormModel> {

        return this.http.get(`${this.baseUrl}/api/admin/communities/form/reads/v1/${id}`, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    // Todos los formularios por comunidad
                    let allCommunityForm = result;

                    return allCommunityForm;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de los cupones: ${errMsg}`));
                }
            );
    }

    // GET: api/admin/communities/form/reads/v1/{id}
    getCheckoutFullCommunityForm(id: number, country: Country): Promise<CommunityFormModel> {

        return this.http.get(`${this.baseUrl}/api/admin/communities/form/reads/v1/${id}`, this.getHttpOptionsWithoutSession(country))
            .toPromise().then(
                (result: any) => {

                    // Todos los formularios por comunidad
                    let allCommunityForm = result;

                    return allCommunityForm;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar información de los cupones: ${errMsg}`));
                }
            );
    }

    // // POST: api/admin/communities/form/create/v1
    postCommunityForm(communityFormModel: CommunityFormModel): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/communities/form/create/v1`, communityFormModel, this.getHttpOptions())
            .toPromise();
    }

    // POST api/admin/communities/customer/requestcode/reads/v1/${code}
    checkUniqueLinkCode(code: string, country: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/communities/customer/requestcode/reads/v1/${code}`, null, this.getHttpOptionsWithoutSession(country))
            .toPromise();
    }

    // POST: api/admin/communities/customer/create/v1
    postCommunityCustomer(communityCustomerModel: CommunityCustomerModel, country?: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/communities/customer/create/v1`, communityCustomerModel, this.getHttpOptions(country))
            .toPromise();
    }

    // POST: api/admin/communities/customer/create/v1
    postCheckoutCommunityCustomer(communityCustomerModel: CommunityCustomerModel, country: Country): Promise<any> {

        return this.http.post(`${this.baseUrl}/api/admin/communities/customer/create/v1`, communityCustomerModel, this.getHttpOptionsWithoutSession(country))
            .toPromise();
    }
}